import {cloneDeep} from 'lodash';
import {PROJECT_STATUS} from '../../../../../constants';
import Util from '../../../util/util';

export const formatProjectOption = (project, idx) => {
	const projectNode = project.node ? project.node : project;
	return {
		value: projectNode.id,
		label: projectNode.name,
		name: projectNode.name, // Needed for projectIndicator
		projectId: projectNode.id,
		projectColor: projectNode.projectColor,
		harvestProject: projectNode.harvestProject,
		unit4Project: projectNode.unit4Project,
		companyProjectId: projectNode.companyProjectId,
		cy: 'project-option-' + projectNode.name,
	};
};

export const formatTaskOption = task => {
	const taskNode = task.node ? task.node : task;
	return {
		value: taskNode.id,
		label: 'T' + taskNode.companyTaskId + ' ' + taskNode.name,
		name: taskNode.project.name, // Needed for projectIndicator
		projectColor: taskNode.project.projectColor,
		companyProjectId: taskNode.project.companyProjectId,
		project: formatProjectOption(taskNode.project),
		timeLeft: taskNode.timeLeft,
		parentTaskId: taskNode.parentTaskId,
		cy: 'task-option-' + taskNode.name.replace(' ', ''),
	};
};

export const formatIdleTimeOption = idleTime => {
	const idleTimeNode = idleTime.node ? idleTime.node : idleTime;
	return {
		value: idleTimeNode.id,
		label: idleTimeNode.name,
		idleTimeId: idleTimeNode.id,
		isInternalTime: idleTimeNode.isInternalTime,
	};
};

export const formatProjectOptions = (projects, formatMessage) => {
	const projectOptions = [],
		planning_projects = [],
		running_projects = [];
	const sortedProjects = cloneDeep(projects.edges).sort((a, b) => Util.sortAlphabetically(a.node.name, b.node.name));
	sortedProjects.forEach((project, idx) => {
		if (project.node.status === PROJECT_STATUS.PLANNING) {
			const obj = formatProjectOption(project, idx);
			planning_projects.push(obj);
		} else if (project.node.status === PROJECT_STATUS.RUNNING) {
			const obj = formatProjectOption(project, idx);
			running_projects.push(obj);
		}
	});

	projectOptions.push(
		{value: 'running_projects', label: formatMessage({id: 'project_status.running'}), nestedOptions: running_projects},
		{value: 'planning_projects', label: formatMessage({id: 'project_status.planning'}), nestedOptions: planning_projects}
	);

	return projectOptions;
};

export const formatTaskOptions = (tasks, formatMessage) => {
	const taskOptions = [];
	let taskObjects = [];
	if (tasks && tasks.edges.length > 0) {
		for (const task of tasks.edges) {
			const taskObj = formatTaskOption(task);
			taskObjects.push(taskObj);
			taskObjects.sort((a, b) => a.companyProjectId - b.companyProjectId);
		}
	}

	taskOptions.push({value: 'tasks', label: formatMessage({id: 'common.tasks'}), nestedOptions: taskObjects, forceExpand: true});

	return taskOptions;
};
